import onmount from 'onmount'

const PASSWORD_STEP = 'password'
const ACTIVATION_STEP = 'activation'
const EMAIL_STEP = 'email'

onmount('[data-component=two-step-login]', function () {
  const form = this
  const emailField = form.querySelector('input[name=email]')
  const passwordField = form.querySelector('input[name=password]')
  const stepField = form.querySelector('[data-login-step-field]')
  const passwordStep = form.querySelector('[data-login-password-step]')
  const activationStep = form.querySelector('[data-login-activation-step]')
  const resendLink = form.querySelector('[data-login-resend-link]')
  const continueButton = form.querySelector('[data-login-continue]')

  if (
    !emailField || !passwordField || !stepField || !passwordStep ||
    !activationStep || !resendLink || !continueButton
  ) {
    return
  }

  const showEmailStep = function () {
    stepField.value = EMAIL_STEP
    passwordStep.hidden = true
    activationStep.hidden = true
    continueButton.hidden = false
  }

  const showPasswordStep = function () {
    stepField.value = PASSWORD_STEP
    passwordStep.hidden = false
    activationStep.hidden = true
    continueButton.hidden = true
    passwordField.focus()
  }

  const showActivationStep = function (resendActivationUrl) {
    stepField.value = ACTIVATION_STEP
    resendLink.href = resendActivationUrl || '#'
    passwordStep.hidden = true
    activationStep.hidden = false
    continueButton.hidden = true
    resendLink.focus()
  }

  const checkEmailStatus = async function () {
    if (!emailField.checkValidity()) {
      emailField.reportValidity()
      return
    }

    continueButton.disabled = true

    try {
      const url = new URL(form.dataset.emailStatusUrl, window.location.origin)
      url.searchParams.set('email', emailField.value)

      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })

      if (!response.ok) {
        showPasswordStep()
        return
      }

      const data = await response.json()

      if (data.step === ACTIVATION_STEP) {
        showActivationStep(data.resendActivationUrl)
      } else {
        showPasswordStep()
      }
    } catch (error) {
      showPasswordStep()
    } finally {
      continueButton.disabled = false
    }
  }

  continueButton.addEventListener('click', checkEmailStatus)

  form.addEventListener('submit', function (event) {
    if (stepField.value !== PASSWORD_STEP) {
      event.preventDefault()
      checkEmailStatus()
    }
  })

  emailField.addEventListener('input', showEmailStep)

  if (form.dataset.initialStep === PASSWORD_STEP) {
    showPasswordStep()
  } else if (form.dataset.initialStep === ACTIVATION_STEP) {
    showActivationStep(form.dataset.resendActivationUrl)
  } else {
    showEmailStep()
  }
})
